<template>
  <div id="orderMenuConfirmation">
    <Confirmation />
  </div>
</template>

<script>
import Confirmation from "@/components/page-components/Checkout/Confirmation.vue";

export default {
  components: {
    Confirmation,
  },
};
</script>

<style scoped lang="scss">
@import '@/css/customizer';
</style>
